import * as at from "../actions/types";

const initialState = {
  nav: [],
};

const breadcrumbs = (state = initialState, action) => {
  switch (action.type) {
    case at.SET_BREADCRUMBS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default breadcrumbs;
